@font-face {
  font-family: RichTextListIcon;
  src: url("./list-icon.woff");
}
